import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

// August 6th: refactored for responsiveness
const Elements = () => {
    return (
        <div className="w3-container w3-content pt-8 pb-8 d-flex row-column">
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="bg-white w-100 p-4 w3-card">
                <Title text="Ball" />
                <p className="margin-top gray">Each team must bring a ball.</p>
                <p className="gray">U6 U7 U8 - size #3, U9-U12 - size #4, U13 and older - size #5.</p>
            </ScrollAnimation>
            <div style={{ width: 30, height: 10 }} />
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="bg-white w-100 p-4 w3-card">
                <Title text="Awards" />
                <p className="margin-top gray">Individual awards for 1st, 2nd & 3rd place, plus all U8 and younger players get individual awards.</p>
            </ScrollAnimation>
            <div style={{ width: 30, height: 10 }} />
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="bg-white w-100 p-4 w3-card">
                <Title text="Schedules" />
                <p className="margin-top gray"> Event schedules are typically posted through the event information page by the Thursday night (or 2 days) before the tournament.</p>
            </ScrollAnimation>
        </div>
    );
}

export default Elements;



// WEBPACK FOOTER //
// ./src/components/information/partials/elements.js